import { useTranslation } from 'react-i18next';
import { BrandLogo } from '@/components/common/BrandLogo';
import { Icon } from '@/components/common/Icon';
import { LanguageSwitcher } from '@/components/common/LanguageSwitcher';
import { Button } from '@/components/ui/button';
import { useAuth } from '@/hooks/useAuth';

export function PortalGateHeader() {
  const { t } = useTranslation('clients');
  const { logOut } = useAuth();

  return (
    <header className="bg-zoowhite border-b border-zooborder px-4 sm:px-5 py-3 flex flex-wrap items-center justify-between gap-2">
      <BrandLogo className="h-7 w-auto object-contain shrink-0" />
      <div className="flex items-center gap-2 shrink-0">
        <LanguageSwitcher />
        <Button
          variant="destructiveGhost"
          size="icon"
          aria-label={t('portal.logout')}
          title={t('portal.logout')}
          onClick={function handleLogout() {
            logOut();
          }}
        >
          <Icon name="LogOut" />
        </Button>
      </div>
    </header>
  );
}
